import React, { useContext, useEffect, useState } from 'react'
import styles from './BasicInformation.module.css'
import { FormTitle } from '../../../../Common/FormTitle'
import { NextButton } from '../../../../Common/CtaButton/NextButton'
import { HandleBlurFunction } from '../../LoginInformation/types'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'
import { StepContext } from '../../../StepContainer'
import { validatePassword } from '../../LoginInformation/validate'
import { PasswordField } from './PasswordField'

export const JobSeekerPasswordOnly = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { formState } = useContext(StepContext)

    const [password, setPassword] = useState(formState.password || '')
    const [passwordTouched, setPasswordTouched] = useState({ password: false })
    const [passwordErrors, setPasswordErrors] = useState({ password: '' })

    useEffect(() => {
        const passwordError = validatePassword(password, passwordTouched.password)
        setPasswordErrors({ password: passwordError || '' })
    }, [password, passwordTouched])

    const handlePasswordBlur: HandleBlurFunction = field => {
        setPasswordTouched(prev => ({
            ...prev,
            [field]: true,
        }))
    }

    const isFormValid = password.length >= 8 && !passwordErrors.password

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText={<>最後に、ログイン用の<br/>パスワードを設定しましょう</>}
                        dataViewLabel={dataViewLabel('EF_StepForm_パスワード')}
                        dataClickLabel={dataClickLabel('EF_StepForm_パスワード-戻る')}
                    />
                </div>

                <PasswordField
                    password={password}
                    setPassword={setPassword}
                    passwordErrors={passwordErrors}
                    onBlur={handlePasswordBlur}
                    dataClickLabel={dataClickLabel}
                    showLoginLink={false}
                    showVisibilityToggle
                />

                <NextButton
                    formKey={['password']}
                    formValue={[password]}
                    displayFormKey={['password']}
                    displayFormValue={[password ? '********' : '']}
                    isDisabled={!isFormValid}
                    confirmation={'確認画面へ'}
                    dataClickLabel={dataClickLabel('EF_StepForm_パスワード-確認画面へ')}
                />
            </div>
        </div>
    )
}
